module.exports = __webpack_public_path__ + "assets/img/dayu_online_code.3978606d.png";